import { Building2 } from 'lucide-react'

export function MemberPortalOrganizationDisclosure({
  path,
  organizations = [],
}: {
  path: string
  organizations?: Array<{ id: number; name: string }>
}) {
  if (path !== '/portal/profile' || !organizations.length) return null
  return (
    <div className="mt-4 space-y-1.5 rounded-md bg-accent/40 px-3 py-2.5">
      {organizations.map((organization) => (
        <p key={organization.id} className="flex items-start gap-2 text-body-sm text-foreground">
          <Building2 className="mt-0.5 size-4 shrink-0 text-primary" aria-hidden="true" />
          <span>
            {organization.name} can see your event bookings, courses, purchases, groups and
            membership level from your time there.
          </span>
        </p>
      ))}
    </div>
  )
}
